/**
 * Wrapper type for relation type definitions in entities.
 * Used to circumvent ESM modules circular dependency issue caused by reflection metadata saving the type of the property.
 *
 * @example
 * Usage example:
 * ```
 * \@Entity()
 * export default class User {
 *     \@OneToOne(() => Profile, profile => profile.user)
 *     profile: Relation<Profile>;
 * }
 * ```
 *
 */
export type Relation<T> = T
